import request from './request.js';


export async function page (params = {
}) {
    return await request('/companyTodo/page', 'get', params)
}

export async function loadTaxMyTodoTask (params = {
}) {
    return await request('/batch/loadTaxMyTodoTask', 'post', params)
}
